<template><div></div></template>

<script>
import { PLAN_TYPES } from '../views/plansSubscriptions/constants'
import { featuresEnum, checkFeatures } from '@/utils/featureUtils'

const rolesEnum = {
  IS_PLAN_CORPORATE: 'isPlanCorporate',
  IS_NOT_PLAN_FREE: 'isNotPlanFree',
  IS_SENDIT_USER: 'isSenditUser',
  IS_DEFAULT_ROUTE: 'isDefaultRoute',
  HAS_BALANCE_BILLING_READ: 'hasBalanceBillingRead',
  HAS_ORGANIZATION_CREATE: 'hasOrganizationCreate',
  CAN_ACCESS_TWO_WAY: 'canAccessTwoWay',
}

export default {
  name: 'navItems',
  data() {
    return {
      canAccessTwoWay: true,
      userItems: [
        {
          name: this.$t('settings.menu.option.basicInfo'),
          class: 'CSidebarNavDropdownItem--disable',
          to: { name: this.$route.params.organizationId ? 'basic-info' : 'basic-info-default' },
        },
        {
          name: this.$t('settings.menu.option.security'),
          class: 'CSidebarNavDropdownItem--disable',
          to: { name: this.$route.params.organizationId ? 'user-security' : 'security-default' },
        },
        {
          name: this.$t('settings.menu.option.api'),
          class: 'CSidebarNavDropdownItem--disable',
          to: { name: this.$route.params.organizationId ? 'api-key' : 'api-key-default' },
        },
      ],
      orgItems: [
        {
          name: this.$t('settings.menu.option.organization'),
          class: 'CSidebarNavDropdownItem--disable',
          item: 'mainOrganization',
          to: { name: 'mainOrganization' },
        },
        {
          id: 'subOrganization',
          name: this.$t('settings.menu.option.subOrganization'),
          class: 'CSidebarNavDropdownItem--disable',
          item: 'subOrganization',
          to: { name: 'subOrganization' },
          roles: [rolesEnum.IS_PLAN_CORPORATE, rolesEnum.HAS_ORGANIZATION_CREATE],
        },
        {
          name: this.$t('settings.menu.option.user'),
          class: 'CSidebarNavDropdownItem--disable',
          item: 'users-list',
          to: { name: 'users-list' },
        },
      ],
      orgDefaultItems: [
        {
          name: this.$t('settings.menu.option.create-organization'),
          class: 'CSidebarNavDropdownItem--disable',
          item: 'mainOrganization',
          to: { name: 'createOrganization-default' },
        },
      ],
      plansSubscritionsItems: [
        {
          name: this.$t('settings.menu.option.plan-overview'),
          class: 'CSidebarNavDropdownItem--disable',
          to: { name: 'plan-overview' },
        },
        {
          name: this.$t('settings.menu.option.plan-invoices'),
          class: 'CSidebarNavDropdownItem--disable',
          to: { name: 'plan-invoices' },
        },
        {
          name: this.$t('settings.menu.option.usage-report'),
          class: 'CSidebarNavDropdownItem--disable',
          to: { name: 'plan-usage-report' },
          roles: [rolesEnum.IS_NOT_PLAN_FREE],
        },
      ],
      senderItems: [
        {
          name: this.$t('settings.menu.option.smsSenders'),
          class: 'CSidebarNavDropdownItem--disable',
          to: { name: 'senders-sms' },
        },
        {
          name: this.$t('settings.menu.option.domainSenders'),
          class: 'CSidebarNavDropdownItem--disable',
          to: { name: 'senders-domain' },
        },
      ],
      twoWayItems: [
        {
          name: this.$t('settings.menu.option.twoWayConfiguration'),
          class: 'CSidebarNavDropdownItem--disable',
          to: { name: 'twoway-configuration' },
        },
        {
          name: this.$t('settings.menu.option.twoWayResults'),
          class: 'CSidebarNavDropdownItem--disable',
          to: { name: 'twoway-results' },
        },
      ],
      historyItems: [
        {
          name: this.$t('settings.menu.option.history'),
          class: 'CSidebarNavDropdownItem--disable',
          to: { name: 'TransactionsHistory' },
        },
      ],
      openedDropdownId: undefined,
    }
  },
  mounted() {
    checkFeatures(featuresEnum.TWO_WAY_MESSAGING).then((res) => (this.canAccessTwoWay = res))
  },
  computed: {
    orgsSubItem() {
      return this.orgItems.filter((item) => {
        return !item.roles || item.roles.every((el) => this.roles.includes(el))
      })
    },
    orgDefaultSubItems() {
      return this.orgDefaultItems.filter((item) => {
        return !item.roles || item.roles.every((el) => this.roles.includes(el))
      })
    },
    userSubItem() {
      return this.userItems.filter((item) => {
        return !item.roles || item.roles.every((el) => this.roles.includes(el))
      })
    },
    plansSubscritionsSubItems() {
      return this.plansSubscritionsItems.filter((item) => {
        return !item.roles || item.roles.every((el) => this.roles.includes(el))
      })
    },
    senderSubItems() {
      return this.senderItems.filter((item) => {
        return !item.roles || item.roles.every((el) => this.roles.includes(el))
      })
    },
    twoWaySubItems() {
      return this.twoWayItems.filter((item) => {
        return !item.roles || item.roles.every((el) => this.roles.includes(el))
      })
    },
    historySubItems() {
      return this.historyItems.filter((item) => {
        return !item.roles || item.roles.every((el) => this.roles.includes(el))
      })
    },
    navItemsMenu() {
      return this.navItems.filter((item) => {
        return !item.roles || item.roles.every((el) => this.roles.includes(el))
      })
    },
    roles() {
      let result = []
      if (this.$store.state.auth.session.organization.planType == PLAN_TYPES.CORPORATE) result.push(rolesEnum.IS_PLAN_CORPORATE)
      if (this.$store.state.auth.session.organization.planType !== PLAN_TYPES.FREE) result.push(rolesEnum.IS_NOT_PLAN_FREE)
      if (this.$store.getters['auth/isSendit']) {
        result.push(rolesEnum.IS_SENDIT_USER)
      }
      if (this.$store.getters['auth/hasSessionPermission']('Balance_Billing_Read')) {
        result.push(rolesEnum.HAS_BALANCE_BILLING_READ)
      }
      if (this.$store.getters['auth/hasSessionPermission']('Organization_Create')) {
        result.push(rolesEnum.HAS_ORGANIZATION_CREATE)
      }
      if (!this.$route.params.organizationId) result.push(rolesEnum.IS_DEFAULT_ROUTE)

      if (this.canAccessTwoWay) result.push(rolesEnum.CAN_ACCESS_TWO_WAY)

      return result
    },
    itemsRoles() {
      return this.items.filter((item) => {
        return !item.roles || item.roles.every((el) => this.roles.includes(el))
      })
    },
    items() {
      return [
        {
          _name: 'CSidebarNavTitle',
          _children: [this.$t('settings.menu.option.settings')],
          name: this.$t('settings.menu.option.settings'),
        },
        {
          _name: 'CSidebarNavDropdown',
          name: this.$t('settings.menu.option.profile'),
          id: 'Profile', // ? ID Usado para identificar o tipo de menu(menuType) definido na rota, pra poder deixar expandido o item quando sele1onar um subitem
          _class: this.dropdownClass('noNeed'),
          _nativeOn: { click: () => this.setOpenedDropdown('Profile') },
          show: this.openedDropdownId == 'Profile',
          dataOrg: 'noNeed',
          icon: 'user',
          items: this.userSubItem,
        },
        {
          _name: 'CSidebarNavDropdown',
          name: this.$t('settings.menu.option.organizationUser'),
          id: 'Organization & Users',
          _class: this.dropdownClass('need'),
          _nativeOn: { click: () => this.setOpenedDropdown('Organization & Users') },
          show: this.openedDropdownId == 'Organization & Users',
          dataOrg: 'need',
          icon: 'building',
          items: this.orgsSubItem,
        },
        {
          _name: 'CSidebarNavDropdown',
          name: this.$t('settings.menu.option.plan-billing'),
          id: 'PlanBilling',
          _class: this.dropdownClass('need'),
          _nativeOn: { click: () => this.setOpenedDropdown('PlanBilling') },
          show: this.openedDropdownId == 'PlanBilling',
          icon: 'dollar',
          dataOrg: 'need',
          items: this.plansSubscritionsSubItems,
          roles: [rolesEnum.HAS_BALANCE_BILLING_READ],
        },
        {
          _name: 'CSidebarNavDropdown',
          name: this.$t('settings.menu.option.senders'),
          id: 'Senders',
          _class: this.dropdownClass('need'),
          _nativeOn: { click: () => this.setOpenedDropdown('Senders') },
          show: this.openedDropdownId == 'Senders',
          dataOrg: 'need',
          icon: 'paperRight',
          items: this.senderSubItems,
        },
        {
          _name: 'CSidebarNavDropdown',
          name: this.$t('settings.menu.option.transactions'),
          id: 'Transacations',
          _class: this.dropdownClass('need'),
          _nativeOn: { click: () => this.setOpenedDropdown('Transacations') },
          show: this.openedDropdownId == 'Transacations',
          icon: 'chartLine',
          dataOrg: 'need',
          items: this.historySubItems,
        },
        {
          _name: 'CSidebarNavItem',
          name: this.$t('settings.menu.option.whitelabel'),
          id: 'Whitelabel',
          _class: this.dropdownClass('need'),
          _nativeOn: { click: () => this.setOpenedDropdown('Whitelabel') },
          show: this.openedDropdownId == 'Whitelabel',
          dataOrg: 'need',
          to: { name: 'whitelabel-config' },
          icon: 'cilColorPalette',
          roles: [rolesEnum.IS_PLAN_CORPORATE, rolesEnum.IS_SENDIT_USER],
        },
        {
          _name: 'CSidebarNavDropdown',
          name: this.$t('settings.menu.option.organization'),
          id: 'Organization Default',
          _class: this.dropdownClass('noNeed'),
          _nativeOn: { click: () => this.setOpenedDropdown('Organization Default') },
          show: this.openedDropdownId == 'Organization Default',
          dataOrg: 'noNeed',
          icon: 'building',
          items: this.orgDefaultSubItems,
          roles: [rolesEnum.IS_DEFAULT_ROUTE],
        },
        {
          _name: 'CSidebarNavDropdown',
          name: this.$t('settings.menu.option.twoWayMessage'),
          id: 'twoWay',
          _class: this.dropdownClass('need'),
          _nativeOn: { click: () => this.setOpenedDropdown('twoWay') },
          show: this.openedDropdownId == 'twoWay',
          dataOrg: 'need',
          icon: 'paperRight',
          items: this.twoWaySubItems,
          roles: [rolesEnum.CAN_ACCESS_TWO_WAY],
        },
      ]
    },
    navItems() {
      return [
        {
          _name: 'CSidebarNav',
          _children: this.itemsRoles,
        },
      ]
    },
    organizationId() {
      return this.$route.params.organizationId
    },
  },
  methods: {
    dropdownClass(dataOrg) {
      if (this.$route.params.organizationId) return ''

      if (dataOrg !== 'need') return ''

      return 'd-none'
    },
    setOpenedDropdown(dropdownId) {
      this.openedDropdownId = dropdownId
    },
  },
}
</script>
